import { saveAs } from "file-saver";
import $ from "jquery";
import moment from "moment";
import React, { Component } from "react";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import SelectAll from "../controls/selectall";
import Translation from "../translation/translation";

class PosterminalReport extends Component {
    sid;
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        if (!Context.IsLogged()) {
            return;
        }
        this.sid = Context.GetContext().Sid;
        let d1 = moment().startOf("day");

        let shops = Comm.GetShopShops({ session: this.sid }).shops;
        this.state = {
            fromDate: d1,
            toDate: d1,
            shops: shops,
            shopId: shops[0].id
        };

        this.ChangeFromDate = this.ChangeFromDate.bind(this);
        this.ChangeToDate = this.ChangeToDate.bind(this);
        this.Report = this.Report.bind(this);
        this.ChangeShop = this.ChangeShop.bind(this);
        this.Export = this.Export.bind(this);
        this.PrintElem = this.PrintElem.bind(this);


    }

    ChangeFromDate(d) {

        d = d || this.state.formDate;


        this.setState({
            fromDate: d,
        });
    }

    ChangeToDate(d) {

        d = d || this.state.toDate;


        this.setState({
            toDate: d,
        });
    }


    ChangeShop(id) {
        this.setState({ shopId: id })
    }

    Report() {
        let rep = Comm.CallGetServerFunction("shop_new/pos_period", {
            session: this.sid,
            shop: this.state.shopId,
            from: moment(this.state.fromDate).format("YYYYMMDD"),
            to: moment(this.state.toDate).format("YYYYMMDD")
        });
        this.setState({ result: rep.html })
    }


    Export(content) {
        var html =
            "<html><head><meta http-equiv='Content-Type' content='text/html; charset=utf-8' /></head><body>" +
            content +
            "</body></html>";
        var file = new Blob([html]);
        saveAs(file, "export.xls");
    }



    RotateColumns(document) {
        var headings = document.getElementsByClassName("vert");
        for (var iter = 0; iter < headings.length; iter++) {
            var h = headings[iter];
            var label = h.innerText.trim();
            h.innerHTML = "";
            var canvas = document.createElement("canvas");
            var context = canvas.getContext("2d");
            context.font = h.style.font;
            context.textAlign = "right";
            context.save();
            var metrics = context.measureText(label);
            canvas.height = parseInt(metrics.width, 10);
            canvas.width = context.measureText("M").width; //най-точно приближение
            context.restore();
            context.font = h.style.font;
            //context.fillStyle = "#ff0000"; // red
            context.textAlign = "right";

            // hold top-right hand corner when rotating
            context.translate(canvas.width - 1, 0);
            //context.translate(0, 0);

            context.rotate((3 * Math.PI) / 2);

            context.fillText(label, 0, 0);
            h.appendChild(canvas);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.RotateColumns(document);
    }

    PrintElem() {
        var mywindow = window.open("", "PRINT", "height=400,width=600");

        mywindow.document.write("<html><head><title>" + document.title + "</title>");
        mywindow.document.write("<style>@media print {@page {size: landscape}}</style>");
        mywindow.document.write("</head><body >");
        //mywindow.document.write('<h1>' + document.title + '</h1>');
        mywindow.document.write(this.state.result);
        mywindow.document.write("</body></html>");

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/
        this.RotateColumns(mywindow.document);
        mywindow.print();
        mywindow.close();

        return true;
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        if (Context.RenderNotOK(this.props.history)) return null;

        let self = this;
        return Context.HasRight("rposterminal") ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("deliveries")}</div>
                <div className="panel-body">
                    <div className="col-md-3">
                        <select className="form-control" value={self.state.ShopId} onChange={(e) => self.ChangeShop(e.target.value)}>
                            {
                                self.state.shops.map((obj) => <option value={obj.id}>{obj.name}</option>)

                            }
                        </select>
                    </div>
                    <div className="col-md-3">
                        <Datetime
                            inputProps={{
                                placeholder: "N/A",
                                readOnly: true,
                                className: "form-control pointhand",
                            }}
                            dateFormat="DD.MM.YYYY"
                            timeFormat=""
                            onChange={this.ChangeFromDate}
                            value={this.state.fromDate}
                            closeOnSelect="true"
                        ></Datetime>
                    </div>
                    <div className="col-md-3">
                        <Datetime
                            inputProps={{
                                placeholder: "N/A",
                                readOnly: true,
                                className: "form-control pointhand",
                            }}
                            dateFormat="DD.MM.YYYY"
                            timeFormat=""
                            onChange={this.ChangeToDate}
                            value={this.state.toDate}
                            closeOnSelect="true"
                        ></Datetime>
                    </div>
                    <div className="col-md-3">
                        <button
                            type="button"
                            className="btn btn-default"
                            onClick={() => self.Report()}
                        >
                            {Translation.Trans("report")}
                        </button>
                    </div>

                    <p>&nbsp;</p>
                    {this.state.result ? (
                        [<div className="col-md-12">
                            <div className="col-md-12" dangerouslySetInnerHTML={{ __html: this.state.result }}></div>

                        </div>,
                        <div className="col-md-12">
                            <button className="btn btn-primary" onClick={this.PrintElem}>
                                <i className="fa fa-print"></i>
                                <p>{Translation.Trans("print")}</p>
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={() => { this.Export(this.state.result); }}
                            >
                                <i className="fas fa-table"></i>
                                <p>{Translation.Trans("export")}</p>
                            </button>
                        </div>
                        ]
                    ) : null}

                </div>

            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }
}

export default PosterminalReport;



// WEBPACK FOOTER //
// ./src/pages/posterminalreport.js